import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListModule } from 'src/@fury/shared/list/list.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import {DragDropModule} from '@angular/cdk/drag-drop';

import { CoveredItemsRoutingModule } from './covered-items-routing.module';
import { CoveredItemsComponent } from './covered-items.component';
import { CoveredItemsListComponent } from './covered-items-list/covered-items-list.component';
import { CoveredItemAddEditComponent } from './covered-item-add-edit/covered-item-add-edit.component';
import { LayoutModule } from 'src/app/layout/layout.module';
import { CoveredItemsDetailsComponent } from './covered-items-details/covered-items-details.component';


@NgModule({
  declarations: [
    CoveredItemsComponent,
    CoveredItemsListComponent,
    CoveredItemAddEditComponent,
    CoveredItemsDetailsComponent
  ],
  imports: [
    CommonModule,
    CoveredItemsRoutingModule,
    FurySharedModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    DragDropModule,
    LayoutModule
  ]
})
export class CoveredItemsModule { }
